module.exports = __webpack_public_path__ + "static/media/gamification_2_zh_HK.9db3c170.png";